import * as React from "react";
import { EndOfQuotesTurnPageLink } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Display/Quotes/TurnPageLink/EndOfQuotesTurnPageLink";
import { DisplayBookOfMindQuote } from "source/app/presentation/MainPanel/Workflows/BookOfMind/DisplayQuote/DisplayBookOfMindQuote";
import { TurnPageLink } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Tools/TurnPageLink/TurnPageLink";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import { bookOfMindSpeech } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Speech/BookOfMindSpeech";
import stringHash from "string-hash";
import { IBookOfMindState } from "../../Helpers/IBookOfMindState";

export function DisplayQuotes({ state }: { state: IBookOfMindState }) {
    const [pageAudioState, setPageAudioState] = React.useState(
        bookOfMindSpeech.GetPageAudioSnapshot().state
    );
    const quotes = state.remainingQuotesToDisplay;
    var quotesToDisplay = quotes.slice(0, state.numberOfQuotesToDisplay);
    var quotesToDisplaySerialized = JSON.stringify(quotesToDisplay);
    var quotesToDisplayHash = stringHash(quotesToDisplaySerialized);

    React.useEffect(() => {
        const unsubscribe = bookOfMindSpeech.SubscribePageAudio((snapshot) => {
            setPageAudioState(snapshot.state);
        });
        return () => {
            unsubscribe();
        };
    }, []);

    const turnPageLinkFadeInTime = 0;
    const hasNextPage =
        state.remainingQuotesToDisplay.length > state.numberOfQuotesToDisplay;
    const showTopTurnPageLink =
        hasNextPage &&
        (pageAudioState === "preparing" ||
            pageAudioState === "playing" ||
            pageAudioState === "paused");
    const topLinkContainerClass = StyleClass(
        "bookOfMindPageAudioNextPageContainer",
        {
            display: "flex",
            justifyContent: "center",
            margin: "0 0 14px",
        }
    );
    const topLinkClass = StyleClass("bookOfMindPageAudioNextPage", {
        display: "inline-flex",
        alignItems: "center",
        boxSizing: "border-box",
        padding: "2px 8px",
        border: "1px solid rgba(143, 107, 55, 0.16)",
        borderRadius: "4px",
        background: "rgba(255, 255, 255, 0.035)",
        color: "rgba(235, 230, 211, 0.88)",
        opacity: 0.74,
        lineHeight: "20px",
        textShadow: "none",
        transition: "background 120ms ease, border-color 120ms ease, color 120ms ease",
        ":hover": {
            borderColor: "rgba(173, 139, 62, 0.34)",
            background: "rgba(173, 139, 62, 0.18)",
            color: "rgba(245, 226, 164, 0.98)",
        },
        ":active": {
            borderColor: "rgba(143, 107, 55, 0.28)",
            background: "rgba(0, 0, 0, 0.3)",
        },
    });
    const topLinkClassLink = StyleClass("bookOfMindPageAudioNextPageLink", {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textDecoration: "none",
    });
    let wordRevealOffset = 0;
    const wordRevealOffsets = quotesToDisplay.map((bomq) => {
        const offset = wordRevealOffset;
        wordRevealOffset += GetWordCount(bomq.quote);
        return offset;
    });

    return (
        <div
            key={quotesToDisplayHash} // forces animations to re-trigger when displayed quotes change
        >
            {showTopTurnPageLink ? (
                <div className={topLinkContainerClass}>
                    <TurnPageLink
                        state={state}
                        withClass={topLinkClass}
                        linkClass={topLinkClassLink}
                    />
                </div>
            ) : null}
            {quotesToDisplay.map((bomq, index) => (
                <DisplayBookOfMindQuote
                    bomq={bomq}
                    index={index}
                    key={index}
                    isSelected={state.selectedQuote === bomq}
                    wordRevealOffset={wordRevealOffsets[index]}
                    spokenQuoteIndex={state.spokenQuoteIndex}
                    spokenWordStartIndex={state.spokenWordStartIndex}
                    spokenWordEndIndex={state.spokenWordEndIndex}
                />
            ))}
            <EndOfQuotesTurnPageLink {...{ turnPageLinkFadeInTime, state }} />
        </div>
    );
}

function GetWordCount(text: string) {
    return text.match(/\S+/g)?.length ?? 0;
}
